import { Box, Spinner } from '@chakra-ui/react'

export const BaseModalSkeleton = () => {
	return (
		<Box
			id="modal-fallback"
			w="full"
			h="100px"
			top={0}
			left={0}
			display="flex"
			alignItems="center"
			justifyContent="center"
		>
			<Spinner
				color="brand.300"
				thickness="0.5rem"
				speed="0.65s"
				size="xl"
			/>
		</Box>
	)
}
